import { ObservableArray, View } from "binder"
import { BillLineItem, ReceiptBillDetailViewModel } from "./receiptBillDetail-viewModel"

export class ReceiptBillDetailView extends View<ReceiptBillDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-67E8C0F8-485D-463A-AD38-A228B82F87BD"
    }
    loadHtml(): string {
        let element = require('./receiptBillDetail.html').default;
        let style = require('./receiptBillDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName; } private _partyName: string;
    public set billNo(v: string) { this._billNo = v; } public get billNo(): string { return this._billNo; } private _billNo: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set lineItems(v: ObservableArray<BillLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<BillLineItem> { return this._lineItems; } private _lineItems: ObservableArray<BillLineItem>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    confirm() {
        this.dataContext.confirm();
    }

    back() {
        this.dataContext.back();
    }

}
